export default function() {
    function findToCartButton(element) {
        const container = element.closest("[data-add-to-basket]");
        if (container) {
            return container.querySelector("[data-add-to-basket-btn]");
        }
    }

    $("body").on("click", "[data-add-to-basket-btn]", (e) => {
        const button = e.currentTarget;
        const addedUrl = "/basket/";
        const currentUrl = button.getAttribute("href");
        const action = button.href;

        if (currentUrl !== addedUrl) {
            e.preventDefault();

            const buttonContainer = button.closest("[data-add-to-basket]");

            let data = {
                "item": button.dataset.itemId,
                "quantity": button.dataset.itemQuantity,
                "add_item": "Y",
                "iblockID": button.dataset.iblockId
            };
    
            $.ajax({
                type: 'POST',
                url: action,
                dataType: 'json',
                data: data,
                beforeSend: function() {
                    if (buttonContainer) buttonContainer.classList.add('is-loading');
                },
                complete: function() {
                    if (buttonContainer) buttonContainer.classList.remove('is-loading');
                },
                success: function(res) {
                    let modalUrl = '/include/modals/cartSuggestions.php';
                    if (data.item)
                        modalUrl = modalUrl + '?item=' + data.item;
    
                    let wishBtn = document.querySelector('[data-to-wish][data-item-id="'+ data.item +'"]');
                    if (wishBtn) {        
                        let textContainer = wishBtn.querySelector('[data-to-wish-text]'),
                        defaultText = wishBtn.dataset.defaultText;
                        
                        textContainer.innerHTML = defaultText;
                        wishBtn.classList.remove('is-active');
                    }
    
                    let buttonText = (button.dataset.itemAddedText) ? button.dataset.itemAddedText : "В корзине";
                    let buttonClass = (button.dataset.itemAddedClass) ? button.dataset.itemAddedClass : "is-added";
    
                    button.innerText = buttonText;
                    button.classList.add(buttonClass);
                    button.href = addedUrl;
    
                    if (buttonContainer) {
                        let quantityControl = buttonContainer.querySelector("[data-basket-quantity-input]");
                        if (quantityControl) {
                            let block = quantityControl.parentElement;
                            if (block) block.classList.add("is-hidden");
                        }
                    }
    
                    /* aspro legacy */
                    if ($("#ajax_basket").length)
                        reloadTopBasket('add', $('#ajax_basket'), 200, 5000, 'Y');
    
                    if ($("#basket_line .basket_fly").length) {
                        basketFly('refresh', 'N');
                    }
                    /* aspro legacy */
    
                    if (res.modalUrl) {
                         modalUrl = res.modalUrl
                    } 
    
                    const eventdata = {action:'loadBasket'};
                    BX.onCustomEvent('onCompleteAction', [eventdata]);
    
                    if(window.matchMedia("(min-width: 992px)").matches) window.loadModalByUrl(modalUrl);
                }
            });
        }
    })

    $("body").on("click", "[data-basket-quantity-change]", (e) => {
        const button = e.currentTarget;
        const actionType = button.dataset.basketQuantityChange;
        const input = button.parentElement.querySelector("[data-basket-quantity-input]");
        const toCartBtn = findToCartButton(button);
        let min = 1;
        let max = +input.max;

        if (actionType === "dec") {
            if (input.min) min = +input.min;
            if (input.value > min) input.value = +input.value - 1;
            input.dispatchEvent(new Event('change'));
            if (toCartBtn) toCartBtn.dataset.itemQuantity = input.value;
        } else if (actionType ==="inc") {
            max = +input.max;
            if (input.value < max) input.value = +input.value + 1
            input.dispatchEvent(new Event('change'));	
            if (toCartBtn) toCartBtn.dataset.itemQuantity = input.value;
        }
    });

    $("body").on("input", "[data-basket-quantity-input]", (e) => {
        const input = e.currentTarget;
        const toCartBtn = findToCartButton(input);
        let max = +input.max;
        if (input.value > max) input.value = max;
        if (toCartBtn) toCartBtn.dataset.itemQuantity = input.value;
    });

    $("body").on("change", "[data-basket-quantity-input]", (e) => {
        const input = e.currentTarget;
        const toCartBtn = findToCartButton(input);
        let min = 1;
        if (input.min) min = +input.min;
        if (input.value < min) input.value = min;
        if (toCartBtn) toCartBtn.dataset.itemQuantity = input.value;
    });
}